import { Transform } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";

export class StockRecordTotalsDto {
  @Transform(({ value }) => toEuros(value))
  total: number;
}
